
        var result = require("!!../../../../node_modules/css-loader/index.js!./finance.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/finance/finance.component.css
// module id = 479
// module chunks = 2